import {
  ActivateTransactionFilter,
  ActivateTransactionFragment,
  useActivateTransactionPointTransactionsQuery,
  useActivateTransactionQuery,
} from '@occc/graphql';

export type ActivateTransactionViewModel = ActivateTransactionFragment & {
  pointTransactions: NonNullable<ActivateTransactionFragment['pointChanges']>;
};

export const useGetActivateTransactionById = (idEquals?: string) => {
  const filter: ActivateTransactionFilter = {
    idEquals,
  };

  const skip = !idEquals;

  const response = useActivateTransactionQuery({
    notifyOnNetworkStatusChange: true,
    variables: { filter },
    skip,
  });

  const pointTransactionsResponse = useActivateTransactionPointTransactionsQuery({
    variables: { filter },
    skip,
    errorPolicy: 'ignore',
  });

  const node = response?.data?.activateTransactions?.edges?.[0]?.node;
  const pointTransactionsFromApi =
    pointTransactionsResponse.data?.activateTransactions?.edges?.[0]?.node?.pointTransactions;

  const data: ActivateTransactionViewModel | undefined = node
    ? {
        ...node,
        pointTransactions: pointTransactionsFromApi ?? node.pointChanges ?? [],
      }
    : undefined;

  return {
    ...response,
    // Reflect both queries so consumers wait for the full view model and don't
    // flicker from the `pointChanges` fallback to `pointTransactions`.
    loading: response.loading || pointTransactionsResponse.loading,
    data,
  };
};
